import { Action } from '@ngrx/store';
import { Document, DocumentForm } from './documents.models';
import { Parameter } from '@ecosure-suite/shared/utils-helpers';

export enum DocumentsActionTypes {
  LOAD_OWNER_DOCUMENTS = '[Documents] Load Owner Documents',
  LOAD_OWNER_DOCUMENTS_SUCCESS = '[Documents] Load Owner Documents Success',
  LOAD_OWNER_DOCUMENTS_FAIL = '[Documents] Load Owner Documents Fail',
  SAVE_DOCUMENT_INFORMATION = '[Document] Save Document Information',
  UPDATE_DOCUMENT_INFORMATION = '[Document] Update Document Information',
  SAVE_UPLOAD = '[Document] Save Upload Document',
  SAVE_UPLOAD_SUCCESS = '[Document] Save Upload Document Success',
  SAVE_UPLOAD_FAIL = '[Document] Save Upload Document Fail',
  UPDATE_UPLOAD = '[Document] Update Upload Document',
  UPDATE_UPLOAD_SUCCESS = '[Document] Update Upload Document Success',
  UPDATE_UPLOAD_FAIL = '[Document] Update Upload Document Fail'
}

export class LoadOwnerDocuments implements Action {
  readonly type = DocumentsActionTypes.LOAD_OWNER_DOCUMENTS;
  constructor(public payload: Parameter) {}
}

export class LoadOwnerDocumentsSuccess implements Action {
  readonly type = DocumentsActionTypes.LOAD_OWNER_DOCUMENTS_SUCCESS;
  constructor(public payload: Document[]) {}
}

export class LoadOwnerDocumentsFail implements Action {
  readonly type = DocumentsActionTypes.LOAD_OWNER_DOCUMENTS_FAIL;
  constructor(public payload: Error) {}
}

export class SaveDocumentInformation implements Action {
  readonly type = DocumentsActionTypes.SAVE_DOCUMENT_INFORMATION;
  constructor(public payload: DocumentForm) {}
}

export class UpdateDocumentInformation implements Action {
  readonly type = DocumentsActionTypes.UPDATE_DOCUMENT_INFORMATION;
  constructor(public payload: DocumentForm) {}
}

export class SaveUpload implements Action {
  readonly type = DocumentsActionTypes.SAVE_UPLOAD;
  constructor(public payload: DocumentForm) {}
}

export class SaveUploadSuccess implements Action {
  readonly type = DocumentsActionTypes.SAVE_UPLOAD_SUCCESS;
  constructor(public payload: Document) {}
}

export class SaveUploadFail implements Action {
  readonly type = DocumentsActionTypes.SAVE_UPLOAD_FAIL;
  constructor(public payload: Error) {}
}

export class UpdateUpload implements Action {
  readonly type = DocumentsActionTypes.UPDATE_UPLOAD;
  constructor(public payload: DocumentForm) {}
}

export class UpdateUploadSuccess implements Action {
  readonly type = DocumentsActionTypes.UPDATE_UPLOAD_SUCCESS;
  constructor(public payload: Document) {}
}

export class UpdateUploadFail implements Action {
  readonly type = DocumentsActionTypes.UPDATE_UPLOAD_FAIL;
  constructor(public payload: Error) {}
}

export type DocumentsAction =
  | LoadOwnerDocuments
  | LoadOwnerDocumentsSuccess
  | LoadOwnerDocumentsFail
  | SaveDocumentInformation
  | UpdateDocumentInformation
  | SaveUpload
  | SaveUploadSuccess
  | SaveUploadFail
  | UpdateUpload
  | UpdateUploadSuccess
  | UpdateUploadFail;

export const fromDocumentsActions = {
  LoadOwnerDocuments,
  LoadOwnerDocumentsSuccess,
  LoadOwnerDocumentsFail,
  SaveDocumentInformation,
  UpdateDocumentInformation,
  SaveUpload,
  SaveUploadSuccess,
  SaveUploadFail,
  UpdateUpload,
  UpdateUploadSuccess,
  UpdateUploadFail
};
